// AUTO-GENERATED by generate-zod-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { z } from 'zod'

export const approvalSchema = z.object({
  id: z.string().max(100),
  orgId: z.string().max(100),
  workspaceId: z.string().max(100).optional(),
  userId: z.string().max(100).optional(),
  createdAt: z.string().max(200).datetime(),
  updatedAt: z.string().max(200).datetime(),
  metadata: z.record(z.string(), z.unknown()).optional(),
  extended: z.record(z.string(), z.unknown()).optional(),
  projectId: z.string().max(100),
  milestoneId: z.string().max(100).optional(),
  taskId: z.string().max(100).optional(),
  documentId: z.string().max(100).optional(),
  title: z.string().max(500),
  type: z.string().max(200),
  category: z.string().max(200),
  categoryName: z.string().max(200),
  status: z.string().max(50),
  documentType: z.string().max(200).optional(),
  documentContent: z.string().max(50000).optional(),
  response: z.string().max(5000).optional(),
  annotations: z.string().max(5000).optional(),
  comments: z.string().max(50000).optional(),
  respondedAt: z.string().max(200).datetime().optional(),
  approverId: z.string().max(100).optional(),
  tenantId: z.string().max(100).optional(),
})

export type ApprovalInput = z.infer<typeof approvalSchema>
